import { Box, Stack, Typography } from '@mui/material';
import React from 'react';

import { ScheduleEmailDeliveryFields } from './ScheduleEmailDeliveryFields';
import { ScheduleEmailFragmentProps } from './ScheduleEmailFragment.props';
import { ScheduleEmailScheduleFields } from './ScheduleEmailScheduleFields';
import { useScheduleEmailForm } from './useScheduleEmailForm';
import { TextField } from '../../../../../components/atoms/TextField';
import {
  FORM_STACK_SX,
  SECTION_HEADING_SX,
  TAB_BODY_SX,
} from '../ReportEditFragment/reportEditDialog.styles';
import { ReportEditDialogFooter } from '../ReportEditFragment/ReportEditDialogFooter';

export const ScheduleEmailFragment: React.FC<ScheduleEmailFragmentProps> = ({
  reportId,
  attachmentTypes,
  handleRefetch,
}) => {
  const form = useScheduleEmailForm(reportId, attachmentTypes, handleRefetch);

  return (
    <>
      <Box sx={TAB_BODY_SX}>
        <Stack spacing={2.5} sx={FORM_STACK_SX}>
          <ScheduleEmailDeliveryFields
            isActive={form.isActive}
            onChangeIsActive={form.setIsActive}
            attachmentTypes={attachmentTypes}
            attachmentType={form.attachmentType}
            onChangeAttachmentType={form.setAttachmentType}
            selectedEmails={form.selectedEmails}
            onChangeSelectedEmails={form.setSelectedEmails}
            newEmails={form.newEmails}
            onChangeNewEmails={form.setNewEmails}
          />

          <Box component="section">
            <Typography sx={SECTION_HEADING_SX}>Message</Typography>
            <Stack spacing={1.75} sx={{ mt: 1 }}>
              <TextField
                label="Subject"
                required
                fullWidth
                value={form.subject}
                onChange={form.setSubject}
              />
              <TextField
                label="Body"
                multiline
                required
                rows={3}
                fullWidth
                value={form.emailBody}
                onChange={form.setEmailBody}
              />
            </Stack>
          </Box>

          <ScheduleEmailScheduleFields
            scheduleType={form.scheduleType}
            onChangeScheduleType={form.onChangeScheduleType}
            scheduleValue={form.scheduleValue}
            onChangeScheduleValue={form.setScheduleValue}
            isCustomSchedule={form.isCustomSchedule}
          />
        </Stack>
      </Box>

      <ReportEditDialogFooter
        primaryLabel={form.isExistingSchedule ? 'Update schedule' : 'Save schedule'}
        onPrimary={form.handleSave}
        primaryDisabled={form.isSaving}
        secondaryLabel="Send test email to me"
        onSecondary={form.handleSendTestEmail}
        secondaryDisabled={form.isSendingTestEmail}
        status={form.testEmailStatus}
      />
    </>
  );
};
